import { render, staticRenderFns } from "./EditHabit.vue?vue&type=template&id=c2872948&scoped=true&"
import script from "./EditHabit.vue?vue&type=script&lang=js&"
export * from "./EditHabit.vue?vue&type=script&lang=js&"
import style0 from "./EditHabit.vue?vue&type=style&index=0&id=c2872948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2872948",
  null
  
)

export default component.exports